import React from 'react';

import { Link } from 'react-router-dom';

import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { Pills } from 'components/common/pills/pills';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import classes from 'components/widgets/PrioritiesMatrix/components/Cards/components/CardsHeader/CardsHeader.module.scss';

export const CardsHeader = ({
    selected,
    linkToBattlecards,
    selectedTypeWithRole,
    buttons,
    isOverdueFilter,
    handleOverdueFilter,
    isDelayDriverFilter,
    handleDelayDriverFilter,
    isCriticalPathFilter,
    handleCriticalPathFilter,
    isAssignedToMeFilter,
    handleAssignedToMeFilter,
}) => {
    return (
        <div data-testid={'cards-header'} className={`${classes.cardsHeader}`}>
            <div className={classes.rowActions}>
                <span>Preview</span>
                <Link to={linkToBattlecards}>View in {executionConfig.battlecards.title}</Link>
            </div>
            <div data-testid={'cards-header-title'} className={classes.cardsHeaderTitle}>
                <span className={classes.cardsHeaderTitleType}>{buttons[selected.type].title}</span> |{' '}
                {selectedTypeWithRole.title} ({selectedTypeWithRole.numOfItem})
            </div>
            <div className={classes.pills}>
                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Top}
                    tooltipContent={'Overdue'}
                    triggerElement={
                        <Pills
                            type={'risk'}
                            className={`${classes.pillWrapper} ${isOverdueFilter ? classes.activeFilter : ''} ${
                                classes[selected.type]
                            }`}
                            onClick={handleOverdueFilter}
                        >
                            <Icon name={'clock'} size={'1.2rem'} color={'#334359'} />
                            <span className={classes.pillsTitle}>Overdue</span>
                            <span>{selectedTypeWithRole.numOfOverdue}</span>
                        </Pills>
                    }
                />
                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Top}
                    tooltipContent={'Delay Drivers'}
                    triggerElement={
                        <Pills
                            type={'info'}
                            className={`${classes.pillWrapper} ${
                                isDelayDriverFilter ? classes.activeFilter : ''
                            } ${classes[selected.type]}`}
                            onClick={handleDelayDriverFilter}
                        >
                            <Icon name={'hour-glass'} size={'1.2rem'} color={'#334359'} />
                            <span className={classes.pillsTitle}>Delay Drivers</span>
                            <span>{selectedTypeWithRole.numOfDelayDriver}</span>
                        </Pills>
                    }
                />
                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Top}
                    tooltipContent={'Critical path'}
                    triggerElement={
                        <Pills
                            type={'info'}
                            className={`${classes.pillWrapper} ${
                                isCriticalPathFilter ? classes.activeFilter : ''
                            } ${classes[selected.type]}`}
                            onClick={handleCriticalPathFilter}
                        >
                            <Icon name={'union'} size={'1.2rem'} color={'#334359'} />
                            <span className={classes.pillsTitle}>Critical path</span>
                            <span>{selectedTypeWithRole.numOfCriticalPath}</span>
                        </Pills>
                    }
                />

                <CustomizedTooltip
                    tooltipPosition={TooltipPosition.Top}
                    tooltipContent={'Assigned to me'}
                    triggerElement={
                        <Pills
                            type={'user'}
                            className={`${classes.pillWrapper} ${
                                isAssignedToMeFilter ? classes.activeFilter : ''
                            } ${classes[selected.type]}`}
                            onClick={handleAssignedToMeFilter}
                        >
                            <MuiIcon icon={'add_task'} fontSize={'15px'} />
                            <span className={classes.pillsTitle}>Assigned to me</span>
                            <span>{selectedTypeWithRole.numOfAssignedToMe}</span>
                        </Pills>
                    }
                />
            </div>
        </div>
    );
};
